const headerInit = () => {
  const open = document.querySelector(".js-toggle-menu-open");
  const menu = document.querySelector(".js-mobile-menu");
  const close = document.querySelector(".js-toggle-menu-close");
  const seperator = Array.from(document.querySelectorAll(".js-seperator"));

  open?.addEventListener("click", () => {
    menu?.classList.add("block");
    open?.classList.add("hidden");
    close?.classList.remove("hidden");

    if (window.innerWidth > 640) {
      seperator?.map((e) => {
        e.classList.add("w-1/2");
      });
    }
  });

  close?.addEventListener("click", () => {
    menu?.classList.remove("block");
    open?.classList.remove("hidden");
    close?.classList.add("hidden");
  });

  window.addEventListener("resize", () => {
    if (window.innerWidth <= 640) {
      seperator?.map((e) => {
        e.classList.remove("w-1/2");
      });
    }

    if (window.innerWidth > 640) {
      seperator?.map((e) => {
        e.classList.add("w-1/2");
      });
    }

    if (window.innerWidth >= 768) {
      menu?.classList.add("hidden");
    } else {
      menu?.classList.remove("hidden");
    }
  });
};

headerInit();
